
// eslint-disable-next-line
import React from "react";

import image1 from "../../assest/arrival_products/phone/phone_1.avif";
import image2 from "../../assest/arrival_products/phone/phone_2.avif";
import image3 from "../../assest/arrival_products/phone/phone_3.avif";
import image4 from "../../assest/arrival_products/phone/phone_4.avif";
import image5 from "../../assest/arrival_products/phone/phone_5.avif";
import image6 from "../../assest/arrival_products/phone/phone_6.avif";
import image7 from "../../assest/arrival_products/phone/phone_7.avif";
import image8 from "../../assest/arrival_products/phone/phone_8.avif";
import image9 from "../../assest/arrival_products/phone/phone_9.avif";
import image10 from "../../assest/arrival_products/phone/phone_10.avif";


import image29 from "../../assest/arrival_products/tv/tv_1.avif";
import image30 from "../../assest/arrival_products/tv/tv_2.avif";
import image31 from "../../assest/arrival_products/tv/tv_3.avif";
import image32 from "../../assest/arrival_products/tv/tv_4.avif";
import image33 from "../../assest/arrival_products/tv/tv_5.avif";
import image34 from "../../assest/arrival_products/camera/camera_1.avif";
import image35 from "../../assest/arrival_products/camera/camera_2.avif";
import image36 from "../../assest/arrival_products/camera/camera_3.avif";
import image37 from "../../assest/arrival_products/camera/camera_4.avif";
import image38 from "../../assest/arrival_products/camera/camera_5.avif";
import image39 from "../../assest/arrival_products/camera/camera_6.avif";
import image40 from "../../assest/arrival_products/camera/camera_7.avif";
import image41 from "../../assest/arrival_products/camera/camera_8.avif";

import { useMemo } from "react";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { EffectCoverflow,Pagination, Navigation,Autoplay } from "swiper/modules";

import { Link } from "react-router-dom";


function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }
  
  const desktopImages = [
    image1, image2, image3, image4, image5, image6, image7, image8, image9, image10,
     image29, image30,
    image31, image32, image33, image34, image35, image36, image37, image38, image39, image40,
    image41
  ];
  
  


const SwiperCard = () => {
  const shuffledImages = useMemo(() => shuffleArray([...desktopImages]), []);

  return (
    <div className="container m-auto py-4 mb-10">
      <h1 style={{fontFamily:"serif"}} className="text-3xl font-bold text-center py-4 mb-4 ">Arrival Products</h1>

      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        loop={true}
        spaceBetween={20}
        slidesPerView={"auto"}
        autoplay={{
            delay: 2000, 
            disableOnInteraction: false,
          }}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
        }}
        breakpoints={{
          320: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 1, 
          },
          1024: {
            slidesPerView: 4,
          },
        }}
        pagination={{
          el: ".swiper-pagination",
          clickable: true,
        }}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          clickable: true,
        }}
        modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
        className="swiper_container"
      >
        {shuffledImages.map((image, index) => (
          <SwiperSlide key={index}>
           <Link to={'/arrival-products'}>
           <img
              className="w-[420px] h-[220px] object-contain "
              src={image}
              alt={`Slide ${index + 1}`}
              loading="lazy"
            />
           </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default SwiperCard;
